
export function initReverseLoopVideos() {
  const videos = document.querySelectorAll(".dynamic-loop");
  videos.forEach((video) => {
    let reverse = false;
    video.addEventListener("ended", function () {
      if (reverse) {
        video.currentTime = video.duration;
        video.playbackRate = -1;
      } else {
        video.currentTime = 0;
        video.playbackRate = 1;
      }
      reverse = !reverse;
      video.play();
    });
  });
}
 